module.exports = __webpack_public_path__ + "static/img/about_ci_h.d025c6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo/about_ci_h.png
// module id = /O4p
// module chunks = 1